
import React from 'react';
import { cn } from '@/lib/utils';

interface AlertProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'destructive' | 'warning';
}

export const Alert: React.FC<AlertProps> = ({ 
  children, 
  className,
  variant = 'default'
}) => {
  return (
    <div className={cn(
      "relative w-full rounded-lg border p-4",
      variant === 'default' && "bg-background text-foreground",
      variant === 'destructive' && "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
      variant === 'warning' && "border-amber-500/50 bg-amber-500/10 text-amber-500 [&>svg]:text-amber-500",
      className
    )}>
      {children}
    </div>
  );
};

export const AlertTitle: React.FC<{ children: React.ReactNode; className?: string }> = ({ 
  children, 
  className 
}) => {
  return (
    <h5 className={cn("mb-1 font-medium leading-none tracking-tight", className)}>
      {children}
    </h5>
  );
};

export const AlertDescription: React.FC<{ children: React.ReactNode; className?: string }> = ({ 
  children, 
  className 
}) => {
  return (
    <div className={cn("text-sm [&_p]:leading-relaxed", className)}>
      {children}
    </div>
  );
};
